import * as React from 'react';
import SlideMenu from 'src/components/common/SlideMenu';
import ECheckForm from '../ECheckForm';

import { IInvoiceEcheck } from '../ECheckForm/ECheckForm';
import i18n from 'src/translation/i18n';

interface IECheckModalMobileProps {
  onCloseMenu: () => void;
  invoices: IInvoiceEcheck[];
  userAccount: string;
}

interface IECheckModalMobileState {
  showSlideMenu: boolean;
}

class ECheckModalMobile extends React.Component<
  IECheckModalMobileProps,
  IECheckModalMobileState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      showSlideMenu: true
    };
  }

  private onCloseSlideMenu = () => {
    this.setState({
      showSlideMenu: false
    });
    this.props.onCloseMenu();
  };

  public componentDidMount() {
    this.forceUpdate();
  }

  public render() {
    return (
      <SlideMenu
        mounted={this.state.showSlideMenu}
        goBackTitle={i18n.t('common.back')}
        level={15 + 30}
        handleCloseMenu={this.onCloseSlideMenu}
      >
        <ECheckForm
          handleCloseModal={this.props.onCloseMenu}
          invoices={this.props.invoices}
          userAccount={this.props.userAccount}
          showTable={false}
        />
      </SlideMenu>
    );
  }
}

export default ECheckModalMobile;
